// extracted by mini-css-extract-plugin
export default {"wrapper":"mGPHCv6KgsM7rd2pXwkj","input":"HQZjeWMEdrNdTVqxy17F"};